import { motion } from "framer-motion";
import { Target } from "lucide-react";

export const NextSteps = ({ steps }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case "high":
        return "text-red-600 bg-red-50";
      case "medium":
        return "text-yellow-600 bg-yellow-50";
      case "low":
        return "text-green-600 bg-green-50";
      default:
        return "text-gray-600 bg-gray-50";
    }
  };

  return (
    <div className="shadow-lg bg-white p-4 rounded-lg h-full">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Target className="w-6 h-6 text-[#80e280]" />
          <h3 className="text-xl font-bold text-gray-900 mb-0">Next Steps</h3>
        </div>
      </div>

      <div className="space-y-4 mb-6">
        {steps.map((step, index) => (
          <motion.div
            key={step.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.6 + index * 0.1 }}
            className={`p-4 rounded-xl border-2 transition-all duration-200 border-solid border-gray-200 bg-white hover:border-[#80e280] text-left`}
          >
            <div className="flex items-start space-x-4">

              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h4
                    className={`text-base font-semibold mb-0 ${
                      step.completed ? "text-green-800" : "text-gray-900"
                    }`}
                  >
                    {step.title}
                  </h4>
                  <span
                    className={`px-2 py-1 rounded-full text-sm font-medium ${getPriorityColor(
                      step.priority
                    )}`}
                  >
                    {step.priority.charAt(0).toUpperCase() +
                      step.priority.slice(1)}
                  </span>
                </div>

                <p
                  className={`text-base mb-2 ${
                    step.completed ? "text-green-700" : "text-gray-600"
                  }`}
                >
                  {step.description}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">
                    Estimated time: {step.estimatedTime}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
